import { useLocale, useTranslations } from 'next-intl'

import { Card } from '@/entities/contract'
import { RoomThumbnail } from '@/entities/room'
import { cn, CopyButton } from '@/shared/lib'
import { Description } from '@/shared/ui'

import { RoomDetailButton } from './room-detail-button'

export type Props = {
  roomName: string
  roomUrl: string | null
  addrLot: string
  addrStreet: string
  picMain: string | null
  roomId: number | null
  contractId: number | null
  isContractDetailPage: boolean
}

export const RoomInformation = ({
  roomName,
  roomUrl,
  addrLot,
  addrStreet,
  picMain,
  roomId,
  contractId,
  isContractDetailPage,
}: Props) => {
  const locale = useLocale()
  const t = useTranslations('lease.room_info')

  const isEnglish = locale === 'en'

  const showRoomDetailButton = isContractDetailPage

  return (
    <Card.Item>
      <Card.ItemTitle>{t('title')}</Card.ItemTitle>
      <Card.ItemContent className="space-y-6">
        <div className="flex justify-between">
          <div className="mr-6">
            <h5 className="typo-hody1 mb-3 font-semibold text-gray-900">
              {roomName}
            </h5>

            <Description.List>
              <Description.Item className="items-start">
                <Description.ItemLabel
                  className={cn('shrink-0', isEnglish && 'min-w-18')}
                >
                  {t('label.road_address')}
                </Description.ItemLabel>
                <Description.ItemValue className="flex items-start gap-2">
                  <span>{addrStreet}</span>
                  <CopyButton
                    value={addrStreet}
                    successMessage={t('toast.address_street_copy_success')}
                  />
                </Description.ItemValue>
              </Description.Item>

              <Description.Item className="items-start">
                <Description.ItemLabel
                  className={cn('shrink-0', isEnglish && 'min-w-18')}
                >
                  {t('label.land_lot_address')}
                </Description.ItemLabel>
                <Description.ItemValue className="flex items-start gap-2">
                  <span>{addrLot}</span>
                  <CopyButton
                    value={addrLot}
                    successMessage={t('toast.address_lot_copy_success')}
                  />
                </Description.ItemValue>
              </Description.Item>
            </Description.List>
          </div>

          <RoomThumbnail
            src={picMain}
            alt={roomName}
            ratio="16:9"
            size={84}
            rounded
          />
        </div>
        {showRoomDetailButton && (
          <RoomDetailButton
            roomId={roomId!}
            contractId={contractId!}
            roomUrl={roomUrl!}
          />
        )}
      </Card.ItemContent>
    </Card.Item>
  )
}
